import React from "react";
import { Box, Flex, HorizontalNav, Pill } from "@catchoftheday/cg-components";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var SearchPillNavigation = function SearchPillNavigation(_ref) {
  var items = _ref.items;
  var slides = items.map(function (_ref2, index) {
    var name = _ref2.name,
        url = _ref2.url,
        selected = _ref2.selected;
    return ___EmotionJSX(Flex, {
      key: index,
      my: "auto",
      ml: index == 0 ? 0 : 1,
      mr: index == items.length ? 0 : 1
    }, ___EmotionJSX(Pill, {
      label: name,
      checked: selected,
      containerProps: {
        flex: "1 0 auto",
        border: "solid 1px",
        borderColor: "ui.borderColor",
        background: "white",
        height: 42,
        paddingX: 5,
        role: "menuitem"
      },
      url: url
    }));
  });
  return ___EmotionJSX(Box, {
    display: "block",
    width: "100%",
    overflowX: "hidden",
    pl: {
      xs: 3,
      md: 7,
      lg: 3
    },
    pr: {
      xs: 3,
      md: 7
    },
    backgroundColor: "ui.backgroundColor",
    zIndex: 2
  }, ___EmotionJSX(Flex, {
    height: 70
  }, ___EmotionJSX(HorizontalNav, {
    navItems: slides
  })));
};